import { Fragment } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { HelpIcon } from 'foundations-components/transitional/components/HelpIcon';
import { clearPerformanceMarksAndMeasures } from 'conversations-thread-view/performance-metrics/operators/gatherPerformanceMetrics';
import { UNIVERSAL_SIDEBAR_MARKERS } from '../../performance-metrics/constants/performanceConstants';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const ThreadTicketCardTitle = ({
  data: {
    isCollapsed
  }
}) => {
  //Don't track how long this card's content takes to render if it's collapsed.
  if (isCollapsed) {
    const marker = `${UNIVERSAL_SIDEBAR_MARKERS.TICKET_CARD}`;
    clearPerformanceMarksAndMeasures(marker);
  }
  return /*#__PURE__*/_jsxs(Fragment, {
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "conversations-inbox-ui.crm-integration.ThreadTicketCard.title"
    }), /*#__PURE__*/_jsx(HelpIcon, {
      "data-test-id": "threadticket-info-icon",
      title: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "conversations-inbox-ui.crm-integration.ThreadTicketCard.info"
      }),
      tooltipPlacement: "top",
      marginInline: "100"
    })]
  });
};
ThreadTicketCardTitle.displayName = 'ThreadTicketCardTitle';
export default ThreadTicketCardTitle;